import { useFormContext } from 'react-hook-form';
import { PartsCategoriesFormSchema } from '../PartsCategoriesFormSchema';

export function usePartsCategoriesForm() {
  const {
    reset: resetForm,
    formState: { isSubmitSuccessful, isLoading: isLoadingForm, isSubmitting: isSubmittingForm },
    watch,
  } = useFormContext<PartsCategoriesFormSchema>();
  const { file } = watch();

  return { resetForm, isSubmitSuccessful, isLoadingForm, isSubmittingForm, file };
}
